<template>
    <div></div>
</template>

<script>
import { getRouteForLoggedInUser } from '@/auth/utils/billing'
export default {
    data () {
        return {
            message: ''
        }
    },
    computed: {
        code () {
            return this.$route.query.code
        }
    },
    created () {
        this.$store.dispatch('createMegazonePopsAuth', { code: this.code }).then(() => {
            this.$router.push(getRouteForLoggedInUser())
        }).catch(() => {
            this.$router.push({ name: 'auth-login' })
        })
    }
}
</script>

<style>

</style>
